import { render, staticRenderFns } from "./sortBar.vue?vue&type=template&id=2bff6b1c&scoped=true&"
import script from "./sortBar.vue?vue&type=script&lang=js&"
export * from "./sortBar.vue?vue&type=script&lang=js&"
import style0 from "./sortBar.vue?vue&type=style&index=0&id=2bff6b1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bff6b1c",
  null
  
)

export default component.exports